import React, { useMemo } from 'react';
import { useGetTemplateEditHistory } from '../../../../query/template';
import TablePagination from '../../../../components/ui/TablePagination';
import ReactTable from 'react-table';
import UserWithAvatar from '../../../../components/ui/UserWithAvatar';
import moment from 'moment';
import { Tag, Tooltip } from 'antd';
import {
  getFieldsDifferenceBetweenTwoObjects,
  mapFieldToReadableText,
} from './utils';
import ViewChangeDetailButton from './ViewChangeDetailButton';

export default function EditHistoryModalContent(props) {
  const { data, isLoading } = useGetTemplateEditHistory(props.template.id);
  const columnDefs = useMemo(() => {
    return [
      {
        Header: 'Action',
        id: 'action',
        maxWidth: 110,
        accessor: row => {
          return (
            <Tag
              color={
                row.action === 'CREATE'
                  ? 'green'
                  : row.action === 'UPDATE'
                  ? 'blue'
                  : row.action === 'DELETE'
                  ? 'red'
                  : 'gray'
              }
            >
              {row.action}
            </Tag>
          );
        },
      },
      {
        Header: 'User',
        id: 'user',
        accessor: row => {
          if (!row.owner) {
            return 'System';
          }
          return <UserWithAvatar user={row.owner} />;
        },
      },
      {
        Header: 'Fields Changed',
        id: 'fields',
        accessor: row => {
          if (row.action === 'CREATE') {
            return 'N/A';
          }
          if (row.action === 'DELETE') {
            return 'All';
          }
          if (row.action === 'UPDATE') {
            const changedFields = getFieldsDifferenceBetweenTwoObjects(
              row.prev,
              row.current,
            )
              .map(field => mapFieldToReadableText[field])
              .filter(Boolean);
            const text = changedFields.join(', ');
            return (
              <div className="flex items-center space-x-2">
                {changedFields.length ? (
                  <ViewChangeDetailButton
                    current={row.current}
                    prev={row.prev}
                  />
                ) : null}
                {changedFields.length ? (
                  <Tooltip title={text}>{text}</Tooltip>
                ) : (
                  <span style={{ color: '#9a9595' }}>Unchanged</span>
                )}
              </div>
            );
          }
        },
      },
      {
        Header: 'Date',
        id: 'timestamp',
        accessor: 'timestamp',
        Cell: ({ value }) => {
          return moment(value).format('YYYY/MM/DD HH:mm A');
        },
      },
    ];
  }, []);
  return (
    <ReactTable
      PaginationComponent={TablePagination}
      className={`-highlight`}
      columns={columnDefs}
      data={data}
      defaultPageSize={10}
      firstText={<i className="material-icons">first_page</i>}
      lastText={<i className="material-icons">last_page</i>}
      loading={isLoading}
      minRows={0}
      nextText={<i className="material-icons">chevron_right</i>}
      previousText={<i className="material-icons">chevron_left</i>}
      rowsSelectorText="Rows per page"
      showPageJump={false}
      showPaginationBottom
    />
  );
}
